<div class="gb-item-search">
  <div class="search-input-container">
    <mat-form-field appearance="outline" class="search-items-form-field" [@slideInOut]="searchVisible">
      <button
        mat-stroked-button
        class="search-button"
        [class.disabled]="alwaysVisible"
        (click)="$event.stopPropagation(); toggleSearch()"
      >
        <mat-icon matPrefix>search</mat-icon>
      </button>
      <input
        matInput
        [hidden]="!searchVisible"
        type="search"
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearchChange()"
        [placeholder]="placeholder | translate"
        (blur)="hideSearch()"
      />
    </mat-form-field>
  </div>
</div>
